import { PREFIX } from '../constants/actions';
import { makeAlertActions } from '../../../ui-lottery/src/actions/alerts';

export const { addAlert, clearAlerts } = makeAlertActions(PREFIX);
